import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { AppMessages } from '../../strings';

const ConfirmAcknowledgmentModal = ({shouldShow, onConfirmAcknowledgment, onClose}) => {

  	return (
		<>
			<Modal  show={shouldShow} centered onHide={onClose} className="app-page-text">
				<Modal.Header closeButton >
					<Modal.Title>Acknowledge</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>{AppMessages.confirmAcknowledgment}</p>
				</Modal.Body>
				
				<Modal.Footer>
					<Button onClick={() => onClose()} variant="secondary" className="app-modal-cancel-button">
						Cancel
					</Button>
					<Button onClick={() => onConfirmAcknowledgment()} variant="primary">
						Confirm
					</Button>
				</Modal.Footer>
			</Modal>
		</>
		
  	);
}

export default ConfirmAcknowledgmentModal;